import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addRecentlyViewedModel } from 'services/slices/resourcesHistory';

export const useTrackRecentModel = (modelId: string | undefined) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (modelId) {
      dispatch(addRecentlyViewedModel(modelId));
    }
  }, [modelId, dispatch]);
};
